
import { filterByDate } from './dashboardDataProcessors';
import { getDaysAgo } from './dateUtils';
import { RansomwareItem } from '@/types/dashboard';

/**
 * Process ransomware data
 */
/**
 * Process ransomware data
 */
export function processRansomwareData(ransomwareData: any, days: number = 30) {
  const startDate = getDaysAgo(days);
  const previousStartDate = getDaysAgo(days * 2);
  const ransomwareArray = Array.isArray(ransomwareData) ? ransomwareData : [];

  // Sort ransomware attacks by date (newest first)
  const sortedRansomwareData = [...ransomwareArray].sort((a, b) => {
    return new Date(b.attackdate).getTime() - new Date(a.attackdate).getTime();
  });

  // Filter to only include attacks from the last N days (Current Period)
  const recentRansomwareAttacks = filterByDate(sortedRansomwareData, 'attackdate', startDate) as RansomwareItem[];

  // Filter for previous period (from 2*days ago to days ago)
  const previousRansomwareAttacks = sortedRansomwareData.filter(item => {
    const date = new Date(item.attackdate);
    return date >= previousStartDate && date < startDate;
  });

  // Find the most active ransomware group in the last N days
  const groupCounts: Record<string, number> = {};

  recentRansomwareAttacks.forEach(attack => {
    if (attack.group) {
      const group = attack.group.trim();
      groupCounts[group] = (groupCounts[group] || 0) + 1;
    }
  });

  // Find the group with the highest count
  let mostActiveGroup = 'Unknown';
  let highestCount = 0;

  Object.entries(groupCounts).forEach(([group, count]) => {
    if (count > highestCount) {
      mostActiveGroup = group;
      highestCount = count;
    }
  });

  console.log(`Processed ${recentRansomwareAttacks.length} ransomware attacks from the last ${days} days, most active group: ${mostActiveGroup}`);

  return {
    recentRansomwareAttacks: recentRansomwareAttacks.slice(0, 5), // Limit to 5 items as requested
    allRansomwareAttacks: recentRansomwareAttacks, // Return full list for map
    mostActiveGroup,
    victimCount: recentRansomwareAttacks.length,
    previousVictimCount: previousRansomwareAttacks.length
  };
}
